export default function StarIcon({
  width = 32,
  height = 32,
}: {
  readonly width?: number
  readonly height?: number
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0018 1.66602C16.3824 1.66602 16.73 1.88209 16.8985 2.22339L20.7862 10.0991L29.4802 11.3699C29.8567 11.4249 30.1694 11.6889 30.2868 12.0509C30.4042 12.4129 30.3059 12.8102 30.0333 13.0757L23.7432 19.202L25.2277 27.857C25.292 28.2322 25.1378 28.6113 24.8298 28.8351C24.5218 29.0588 24.1135 29.0883 23.7766 28.9111L16.0018 24.8225L8.22699 28.9111C7.89006 29.0883 7.48176 29.0588 7.17377 28.8351C6.86578 28.6113 6.71153 28.2322 6.77588 27.857L8.26035 19.202L1.97027 13.0757C1.69765 12.8102 1.59937 12.4129 1.71675 12.0509C1.83413 11.6889 2.14682 11.4249 2.5234 11.3699L11.2174 10.0991L15.105 2.22339C15.2735 1.88209 15.6211 1.66602 16.0018 1.66602ZM16.0018 4.92527L12.7784 11.4553C12.6328 11.7502 12.3516 11.9546 12.0263 12.0022L4.81651 13.056L10.0327 18.1363C10.2685 18.3661 10.3762 18.6972 10.3205 19.0217L9.08974 26.1977L15.5363 22.8076C15.8277 22.6544 16.1759 22.6544 16.4672 22.8076L22.9138 26.1977L21.683 19.0217C21.6274 18.6972 21.735 18.3661 21.9709 18.1363L27.187 13.056L19.9773 12.0022C19.6519 11.9546 19.3707 11.7502 19.2252 11.4553L16.0018 4.92527Z"
        fill="black"
      />
    </svg>
  )
}
